import { IAPIAction } from "us.collection/interfaces";
import { ExtendedField } from "us.collection/constants";

export const extendedField: Readonly<IAPIAction> = {
  extendedFields: {
    get: (data) => ({
      type: ExtendedField.GET_EXTENDED_FIELD,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: ExtendedField.GET_EXTENDED_FIELD_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: ExtendedField.GET_EXTENDED_FIELD_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  drawer: {
    set: (data) => ({
      type: ExtendedField.MANAGE_EXTENDED_FIELD_DRAWER,
      payload: {
        data,
        isLoading: true
      }
    }),
    success: (data) => ({
      type: ExtendedField.MANAGE_EXTENDED_FIELD_DRAWER_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: ExtendedField.MANAGE_EXTENDED_FIELD_DRAWER_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }), 
  },
  metaData: {
    get: (data) => ({
      type: ExtendedField.GET_EXTENDED_FIELD_META_DATA,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: ExtendedField.GET_EXTENDED_FIELD_META_DATA_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: ExtendedField.GET_EXTENDED_FIELD_META_DATA_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  extendedFieldData: {
    save: (data) => ({
      type: ExtendedField.UPDATE_EXTENDED_FIELD,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: ExtendedField.UPDATE_EXTENDED_FIELD_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: ExtendedField.UPDATE_EXTENDED_FIELD_FAILURE,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  deleteExtendedField: {
    save: (data) => ({
      type: ExtendedField.DELETE_EXTENDED_FIELD,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: ExtendedField.DELETE_EXTENDED_FIELD_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: ExtendedField.DELETE_EXTENDED_FIELD_FAILURE,
      payload: {
        error,
        isLoading: false,
      },
    }),
  }
};
